export default function createRedirectForLinking(refreshToken: string): string {
  return `/link_anonymous_user/${refreshToken}`;
}
